import {COLORS} from 'frontend/utils/color_palettes';
import {breakerSVG} from 'frontend/utils/icons';

import {AssetMapMarkerData, DefaultMapMarker, IconSize} from './default';

const BREAKER_COLOR = COLORS.NewPrimary.get(40);

export interface BreakerMapMarkerData extends AssetMapMarkerData {
  color?: string;
}

/**
 * A map marker for a breaker.
 */
export class BreakerMapMarker extends DefaultMapMarker<BreakerMapMarkerData> {
  protected override getDefaultIcon(size: IconSize): string {
    return breakerSVG(this.data?.color ?? BREAKER_COLOR, size);
  }
}
